import { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import useResetUser from "../../modules/user/hooks/use-reset-user";
import { getAddLibraryRoute, getLibraryListRoute } from "../../routes/routes";
import TaskCheckbox from "./task-checkbox";

type Props = {}

const Container = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    font-size: 16px;

    .inner {
        border: 2px solid yellow;
        border-radius: 1em;
        background: #e1e1e1;
        padding: 1em;
    }

    .task-controller {
        display: flex;
        padding: .5em;

        .path {
            padding: .5em;
        }
    }
`;

const DevTools: React.FC<Props> = () => {

    const resetUser = useResetUser();
    const [showTaskController, setTaskcontroller] = useState(false);
    const [showDevTools, setShowDevTools] = useState(false);

    return <Container>
        {!showDevTools && <button onClick={() => {setShowDevTools(true)}}>Pokaż narzędzia developerskie</button>}
        {showDevTools && <div className='inner'>

            <h3>Narzędzia developerskie</h3>
            <button onClick={resetUser}>Zresetuj usera</button><br />
            <Link to={getAddLibraryRoute()}>Dodaj nową bibliotekę</Link><br />
            <Link to={getLibraryListRoute()}>Lista bibliotek</Link><br />
            {!showTaskController && <button onClick={() => setTaskcontroller(true)}>Pokaż kontroler zadań</button>}
            {showTaskController && <button onClick={() => setTaskcontroller(false)}>Ukryj kontroler zadań</button>}

            <div className="task-controller">
                <div className="path">
                    {
                        showTaskController && [
                            't-101', 't-102', 't-103', 't-104', 't-105', 't-106'
                        ].map(id => {
                            return <TaskCheckbox id={id} />
                        })
                    }
                </div>
                <div className="path">
                    {
                        showTaskController && [
                            't-201', 't-202', 't-203', 't-204', 't-205', 't-206'
                        ].map(id => {
                            return <TaskCheckbox id={id} />
                        })
                    }
                </div>
                <div className="path">
                    {
                        showTaskController && [
                            't-301', 't-302', 't-303', 't-304', 't-305', 't-306'
                        ].map(id => {
                            return <TaskCheckbox id={id} />
                        })
                    }
                </div>
                <div className="path">
                    {
                        showTaskController && [
                            't-401', 't-402', 't-403', 't-404', 't-405', 't-406'
                        ].map(id => {
                            return <TaskCheckbox id={id} />
                        })
                    }
                </div>
            </div>
            <button onClick={() => {setShowDevTools(false)}}>Ukryj narzędzia developerskie</button>
        </div>}
    </Container>
};

export default DevTools
